var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50,50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 8.333333333333334,
    fill: "none",
    stroke: "#d77ef6",
    strokeWidth: 4,
    strokeDasharray: "26.179938779914945 26.179938779914945"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 0 0;360 0 0",
    times: "0;1",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.2 0 0.8 1",
    begin: 0,
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 16.666666666666668,
    fill: "none",
    stroke: "#ffbf51",
    strokeWidth: 4,
    strokeDasharray: "52.35987755982989 52.35987755982989"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 0 0;360 0 0",
    times: "0;1",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.2 0 0.8 1",
    begin: -0.2,
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 25,
    fill: "none",
    stroke: "#42dca4",
    strokeWidth: 4,
    strokeDasharray: "78.53981633974483 78.53981633974483"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 0 0;360 0 0",
    times: "0;1",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.2 0 0.8 1",
    begin: -0.4,
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 33.333333333333336,
    fill: "none",
    stroke: "#42cfee",
    strokeWidth: 4,
    strokeDasharray: "104.71975511965978 104.71975511965978"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 0 0;360 0 0",
    times: "0;1",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.2 0 0.8 1",
    begin: -0.6,
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 41.666666666666664,
    fill: "none",
    stroke: "#795af7",
    strokeWidth: 4,
    strokeDasharray: "130.89969389957471 130.89969389957471"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 0 0;360 0 0",
    times: "0;1",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.2 0 0.8 1",
    begin: -0.8,
    repeatCount: "indefinite"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.75d2f5024792b9a86c12136a322911e5.svg";
export { ForwardRef as ReactComponent };